/**
 * 水质监测模块（src/views/waterMonitoring）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '编辑': 'Edit',
  '修改': 'Edit',
  '删除': 'Delete',
  '详情': 'Details',
  '查看': 'View',
  '处理': 'Handle',
  '关闭': 'Close',
  '操作': 'Action',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '展开': 'Expand',
  '收起': 'Collapse',
  '导入': 'Import',
  '导出': 'Export',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '正常': 'Normal',
  '异常': 'Abnormal',
  '其他': 'Other',
  '是': 'Yes',
  '否': 'No',
  '备注': 'Remark',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '修改人': 'Modified By',
  '修改时间': 'Modified At',
  '确定删除吗?': 'Are you sure you want to delete?',
  '已选择 {count} 项': '{count} items selected',

  // ── 水质设备 / 校验标准 ──
  '设备ID': 'Device ID',
  '设备类型': 'Device Type',
  '安装位置': 'Installation Location',
  '联网状态': 'Network Status',
  '校验标准': 'Calibration Standard',
  '校对名称': 'Calibration Name',
  '校对标准': 'Calibration Standard',
  '经度': 'Longitude',
  '纬度': 'Latitude',
  '单位': 'Organization',
  '请输入设备ID': 'Please enter device ID',
  '请输入安装位置': 'Please enter installation location',
  '请输入设备类型': 'Please enter device type',
  '请输入校对名称': 'Please enter calibration name',
  '请输入校验标准': 'Please enter calibration standard',
  '请选择校验标准': 'Please select calibration standard',
  '请输入联网状态': 'Please enter network status',
  '请输入单位': 'Please enter organization',
  '请输入经度': 'Please enter longitude',
  '请输入纬度': 'Please enter latitude',
  '请输入备注': 'Please enter remark',
  '请输入备注信息': 'Please enter remark',
  '输入安装位置模糊搜索': 'Enter installation location to search',

  // ── 水质指标及上下限 ──
  '报警状态': 'Alarm Status',
  '请输入报警状态': 'Please enter alarm status',
  '接收时间': 'Received At',
  '请选择接收时间': 'Please select received time',
  '处理时间': 'Handling Time',
  '请选择处理时间': 'Please select handling time',
  '处理说明': 'Handling Remarks',
  '请输入处理说明': 'Please enter handling remarks',
  '酸碱度(pH)': 'pH',
  '温度(℃)': 'Temperature (℃)',
  '浊度(NTU)': 'Turbidity (NTU)',
  '余氯(mg/L)': 'Residual Chlorine (mg/L)',
  '溶解氧(mg/L)': 'Dissolved Oxygen (mg/L)',
  '电导率(mS/cm)': 'Conductivity (mS/cm)',
  '氨氮(mg/L)': 'Ammonia Nitrogen (mg/L)',
  '化学耗氧量(mg/L)': 'Chemical Oxygen Demand (mg/L)',
  '酸碱度上限': 'pH Upper Limit',
  '酸碱度下限': 'pH Lower Limit',
  '温度上限': 'Temperature Upper Limit',
  '温度下限': 'Temperature Lower Limit',
  '浊度上限': 'Turbidity Upper Limit',
  '浊度下限': 'Turbidity Lower Limit',
  '余氯上限': 'Residual Chlorine Upper Limit',
  '余氯下限': 'Residual Chlorine Lower Limit',
  '溶解氧上限': 'Dissolved Oxygen Upper Limit',
  '溶解氧下限': 'Dissolved Oxygen Lower Limit',
  '氧化还原上限': 'ORP Upper Limit',
  '氧化还原下限': 'ORP Lower Limit',
  '电导率上限': 'Conductivity Upper Limit',
  '电导率下限': 'Conductivity Lower Limit',
  '氨氮上限': 'Ammonia Nitrogen Upper Limit',
  '氨氮下限': 'Ammonia Nitrogen Lower Limit',
  '化学耗氧量上限': 'Chemical Oxygen Demand Upper Limit',
  '化学耗氧量下限': 'Chemical Oxygen Demand Lower Limit',
  '酸碱度上限：': 'pH Upper Limit: ',
  '酸碱度下限：': 'pH Lower Limit: ',
  '温度上限：': 'Temperature Upper Limit: ',
  '温度下限：': 'Temperature Lower Limit: ',
  '浊度上限：': 'Turbidity Upper Limit: ',
  '浊度下限：': 'Turbidity Lower Limit: ',
  '余氯上限：': 'Residual Chlorine Upper Limit: ',
  '余氯下限：': 'Residual Chlorine Lower Limit: ',
  '溶解氧上限：': 'Dissolved Oxygen Upper Limit: ',
  '溶解氧下限：': 'Dissolved Oxygen Lower Limit: ',
  '氧化还原上限：': 'ORP Upper Limit: ',
  '氧化还原下限：': 'ORP Lower Limit: ',
  '电导率上限：': 'Conductivity Upper Limit: ',
  '电导率下限：': 'Conductivity Lower Limit: ',
  '氨氮上限：': 'Ammonia Nitrogen Upper Limit: ',
  '氨氮下限：': 'Ammonia Nitrogen Lower Limit: ',
  '化学耗氧量上限：': 'Chemical Oxygen Demand Upper Limit: ',
  '化学耗氧量下限：': 'Chemical Oxygen Demand Lower Limit: ',
  '请输入酸碱度上限': 'Please enter pH upper limit',

  // ── 消息接收人 / 推送 ──
  '推送账号': 'Push Account',
  '推送类型': 'Push Type',
  '短信': 'SMS',
  '微信': 'WeChat',
  '水表': 'Water Meter',
  '水质监测': 'Water Quality Monitoring',
  '压力液位': 'Pressure & Liquid Level',
  '激活状态': 'Activation Status',
  '激活': 'Activate',
  '未激活': 'Not Activated',
  '上级领导': 'Superior',
  '故障类型': 'Fault Type',
  '逆流故障': 'Reverse Flow Fault',
  '存储故障': 'Storage Fault',
  '电池欠压': 'Battery Undervoltage',
  '阀门开故障': 'Valve Open Fault',
  '阀门关故障': 'Valve Close Fault',
  '有磁干扰': 'Magnetic Interference',
  '阀门锈死故障': 'Rusted Valve Fault',
  '请输入推送账号': 'Please enter push account',
  '请输入推送类型': 'Please enter push type',
  '请输入激活状态': 'Please enter activation status',
  '请输入上级领导账号': 'Please enter superior account',
  '请选择故障类型': 'Please select fault type',
  '请关注微信公众号': 'Please follow the WeChat official account',
}
